import React from 'react';
import './AppStoreBadges.css';

const PLAY_STORE_URL_RIDER = 'https://play.google.com/store/apps/details?id=com.tocxi.app';
const APP_STORE_URL_RIDER = 'https://apps.apple.com/in/app/tocxi/id6757497988';

const PLAY_BADGE_SRC = 'https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png';
const APPLE_BADGE_SRC = 'https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83';

function AppStoreBadges({
  playUrl = PLAY_STORE_URL_RIDER,
  appleUrl = APP_STORE_URL_RIDER,
  size = 'md',
  align = 'center',
}) {
  return (
    <div className={`store-badges store-badges--${size} store-badges--${align}`}>
      <a href={playUrl} target="_blank" rel="noopener noreferrer" className="store-badge-link">
        <img
          src={PLAY_BADGE_SRC}
          alt="Get it on Google Play"
          className="store-badge-img store-badge-img--play"
        />
      </a>
      <a href={appleUrl} target="_blank" rel="noopener noreferrer" className="store-badge-link">
        <img
          src={APPLE_BADGE_SRC}
          alt="Download on the App Store"
          className="store-badge-img store-badge-img--apple"
        />
      </a>
    </div>
  );
}

export default AppStoreBadges;
